import Trans from 'next-translate/Trans'
import { GButton, GInput } from 'tennders-common/form/components'
import useSession from 'tennders-auth/hooks/useSession'
import useOffer from 'tennders-market/offer/hooks/useOffer'
import useTransaction from 'tennders-transactions/hooks/useTransaction'
import { withSendOffer } from 'tennders-market/offer/hocs/withSendOffer'
import GHref from 'tennders-market/common/components/element/GHref'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCircleXmark } from '@fortawesome/free-solid-svg-icons'
import React from 'react'

const CounterOffer = ({ sendBid, onChange, form, submitting }) => {
  const {
    counterMode,
    setCounterMode,
    savingRoute,
    errors
  } = useOffer()
  const { isShipperUser, isCarrierUser } = useSession()
  const { transaction } = useTransaction()

  if (!counterMode) {
    return null
  }

  return (
    <div className="open tennders-under-neg-counter-offer bg-color-white br-6 p-16">
      <GHref
        onClick={() => setCounterMode(false)}
        className="tennders-under-neg-counter-offer-close-btn pos-abs-top-right text-18"
      >
        <FontAwesomeIcon icon={faCircleXmark} aria-hidden="true" />
      </GHref>
      <div className="d-flex">
        <GInput
          form={form}
          name="bid"
          errors={errors}
          onChange={onChange}
          withDiv
          label="Enter your offer"
          type="currency"
          labelClass="form-label text-11 mr-8"
          className="form-input bg-color-white"
          placeholder="Your Price €"
        />
        {transaction.isNegotiable && false && (
          <GInput
            withDiv
            form={form}
            name="paymentTerm"
            onChange={onChange}
            label=" Negotiate payment"
            labelClass="form-label text-11"
            type="number"
            className="form-input bg-color-white"
            placeholder="Days"
          />
        )}
      </div>
      <GButton
        disabled={!form.bid || submitting}
        submitting={submitting}
        onClick={sendBid}
        className="btn standard-btn small bold mt-8"
      >
        {savingRoute
          ? <>Saving Route ... </>
          : <Trans i18nKey={'offer:' + (isShipperUser || isCarrierUser ? 'quote' : 'sendBid')} />}
      </GButton>
    </div>
  )
}

export default withSendOffer(CounterOffer)
